export default "__VITE_ASSET__Xhknhrkh__"